<mat-form-field  #formFieldContainer class="textbox-class">
  <mat-label #labelContainer  (click)="toggleTooltip(tooltip)">{{componentDefinition.label}}</mat-label>
  <div class="labelToolTipContainer"
       #tooltip="matTooltip"
       matTooltip="{{componentDefinition.label}}"
       [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)"
  ></div>
  <input matInput placeholder="{{ componentDefinition.label }}"
         [id]="elementName + document.documentId"
         [name]="componentDefinition.name"
         [formControl]="formControl"
         [errorStateMatcher]="matcher">
</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
